import Immutable from 'immutable';
import { PageId } from 'records/Page';
import { Discipline } from 'records/Discipline';

export interface RawSheetVersion {
  sheetid: string;
  sheetnumber: string;
  sheettitle: string;
  discipline: string;
  sheetDiscipline: Discipline;
  issueddate: number;
  revisioncomment: string;
  publishedtimestamp: number;
  publishedBy: string;
  pageid: string;
  documentid: string;
  projectid: string;
  filename: string;
  documentTitle: string;
  pageLabel: string;
  pageIndex: number;
  width: number;
  height: number;
  uploadedBy: string;
  uploadtimestamp: number;
  processingRequestid: string;
  maptilecloudfronturl: string;
  minzoom: number;
  maxzoom: number;
  tilesize: number;
  drawingtilescloudfronturl: string;
  drawingminzoom: number;
  drawingmaxzoom: number;
  drawingtilesize: number;
}

export interface SheetVersionData {
  sheetid: string;
  sheetnumber: string;
  sheettitle: string;
  discipline: string;
  sheetDiscipline: Discipline;
  issueddate: number;
  revisioncomment: string;
  publishedtimestamp: number;
  publishedBy: string;
  pageid: string;
  documentid: string;
  projectid: string;
  filename: string;
  documentTitle: string;
  pageLabel: string;
  pageIndex: number;
  width: number;
  height: number;
  uploadedBy: string;
  uploadtimestamp: number;
  processingRequestid: string;
  maptilecloudfronturl: string;
  minzoom: number;
  maxzoom: number;
  tilesize: number;
  drawingtilescloudfronturl: string;
  drawingminzoom: number;
  drawingmaxzoom: number;
  drawingtilesize: number;
}

const defaultValues: SheetVersionData = {
  sheetid: '',
  sheetnumber: '',
  sheettitle: '',
  discipline: '',
  sheetDiscipline: new Discipline({
    id: '',
    designator: 'unassigned',
    description: 'Unassigned',
  }),
  issueddate: 0,
  revisioncomment: '',
  publishedtimestamp: 0,
  publishedBy: '',
  pageid: '',
  documentid: '',
  projectid: '',
  filename: '',
  documentTitle: '',
  pageLabel: '',
  pageIndex: 0,
  width: 0,
  height: 0,
  uploadedBy: '',
  uploadtimestamp: 0,
  processingRequestid: '',
  maptilecloudfronturl: '',
  minzoom: 0,
  maxzoom: 0,
  tilesize: 0,
  drawingtilescloudfronturl: '',
  drawingminzoom: 0,
  drawingmaxzoom: 0,
  drawingtilesize: 0,
};

export const SheetVersionFactory = Immutable.Record(
  defaultValues,
  'SheetVersion'
);

export class SheetVersion extends SheetVersionFactory {
  serialize(): RawSheetVersion {
    return this.toJS();
  }

  static deserialize(rawSheetVersion: RawSheetVersion): SheetVersion {
    return new SheetVersion({
      ...rawSheetVersion,
      sheetDiscipline: Discipline.deserialize(rawSheetVersion.sheetDiscipline),
    });
  }
}

export type SheetVersionList = Immutable.List<SheetVersion>;

export type SheetVersionMap = Immutable.OrderedMap<PageId, SheetVersion>;
